var defaultBounds = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    height: 0,
    width: 0
};
export var browserPaintingDelay = 100;
/**
 * Get the boundaries, width and height of an HTML element.
 *
 * @param {HTMLElement} domElement - Any HTML element.
 * @returns {Bound} Bound object.
 */
export var getElementBounds = function (domElement) {
    if (!domElement) {
        return defaultBounds;
    }
    var _a = domElement.getBoundingClientRect(), top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left;
    return {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        height: bottom - top,
        width: right - left
    };
};
